import { BaSeMessage, BaSeOptionPicker } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  cycleComboDataToInitialSelectedValuesId,
  cycleComboDataToValues,
  CycleComboModel,
} from '../../main/models/cycle-model';

interface CycleComboContainerProps {
  data?: CycleComboModel[];
  isLoading?: boolean;
  onChange(selectedId: number): void;
  fetchCycleComboError?: Sebrae.HttpErrorModel;
  fetchCycleCombo(): Promise<CycleComboModel[]>;
}
const CycleComboContainer: React.FC<CycleComboContainerProps> = ({
  data,
  isLoading,
  onChange,
  fetchCycleComboError,
  fetchCycleCombo,
}) => {
  if (fetchCycleComboError) {
    return (
      <BaSeMessage
        color="destructive"
        title="Ops! Não foi possível carregar as opções de Ciclo"
        message={fetchCycleComboError.message}
        action="Tentar novamente"
        onAction={() => fetchCycleCombo().catch(() => undefined)}
      />
    );
  }
  return (
    <BaSeOptionPicker
      isLoading={isLoading}
      loadingText="Carregando os ciclos…"
      values={cycleComboDataToValues(data)}
      initialSelectedValuesId={cycleComboDataToInitialSelectedValuesId(data)}
      maxOptionsSelected={1}
      onChange={(selectedValue) => {
        if (selectedValue.length === 0) return;
        const selectedId = selectedValue?.[0]?.id;
        onChange(selectedId);
      }}
    />
  );
};

export { CycleComboContainer };
